module.exports = __webpack_public_path__ + "img/18_37.6d813592.png";